module.exports = __webpack_public_path__ + "static/media/c-step4.97acc1a8.png";